module.exports = __webpack_public_path__ + "img/es50_4.977a7663.png";